import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import axios from 'axios';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Stepper, { Step, StepLabel, StepContent } from 'material-ui/Stepper';
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';
import Input, { InputLabel } from 'material-ui/Input';
import Radio, { RadioGroup } from 'material-ui/Radio';
import { FormLabel, FormControl, FormControlLabel, FormHelperText } from 'material-ui/Form';
import TextField from 'material-ui/TextField';

import { saveData, changeAge } from './actions';

class Question4 extends Component {

  constructor(props){
    super(props);

    this.state = {
      value: "",
      oldage: 50,
      checked: false,
      showPopulation: false,
      popCount: "Loading...",
      popLoaded: false,
      pref_fans: -1,
    };
  }

  onApplyFilter() {

    if (this.state.pref_fans == -1){
      alert("Please select one two choices below.");
    } else {

      //oar_low: 0,oar_high:10,age_low:0,age_high: 75,pref_age:0,income: 0, education: 0,pref_fans: 0
      this.props.saveData(0,10,0,75,this.state.oldage,0,0,this.state.pref_fans);
      this.props.changeRoute("/console/display/adhoc_filters/notifications")
    }
  }

  handleChange = (event, value) => {
     this.setState({ value }, function() {

       if (value == "5"){
         this.setState({
           pref_fans: 1,
         }, function(){

         })
       } else if (value == "10"){
         this.setState({
           pref_fans: 0,
         },function() {

         })
       }
     });
  };

  componentDidMount() {
    this.props.changeAge(this.state.oldage)
  }

  handleLocalAgeChange = prefage => event => {
    this.setState({
      oldage: event.target.value,
      prefage: event.target.value
    }, function() {
      this.props.changeAge(this.state.oldage)
    });
  };

  render(){
    const { classes, theme, location } = this.props;
    const { showPopulation } = this.state;

    return(
      <div className={classes.root}>
        <Typography type="body2" color="inherit" className={classes.flex}>
          4. Preferred Age
        </Typography>
        <br/>
        <Typography>You can check the distribution of the preferred age by tapping the button below:</Typography>
        <br/>
        <div className={classes.buttonDistribution}>
          <Button raised onClick={() => this.props.changeRoute("/console/display/adhoc_filters/distribution_4")} color="primary" align="center" className={classes.button}>See Distribution</Button>
        </div>
        <br/>
        <FormControl aria-describedby="name-helper-text">
          <TextField
            id="prefage"
            label="Age"
            onChange={this.handleLocalAgeChange('prefage')}
            margin="normal"
            value={this.state.oldage}
          />
          <FormHelperText id="name-helper-text">Enter an age between 35 and 65.</FormHelperText>
          <br />
          <br />
          <Typography>Select one of the following:</Typography>
          <RadioGroup aria-label="candidates" name="candidates" value={this.state.value} onChange={this.handleChange} className={classes.group}>
            <FormControlLabel className={classes.radioButton} value="5"  control={<Radio />} label="Include only candidates that gave an answer" />
            <FormControlLabel className={classes.radioButton}  value="10" control={<Radio />} label="Include filtered candidates that DID NOT give an answer." />
          </RadioGroup>
        </FormControl>
        <div className={classes.buttonNext}>
          <Button raised onClick={() => this.onApplyFilter()} color="primary" align="center" className={classes.button}>Apply Filter</Button>
          <Button raised onClick={() => this.props.changeRoute('/console/display/adhoc_filters')} color="primary" align="center" className={classes.button}>Select a different Filter</Button>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
    };
}

function matchDispatchToProps(dispatch){
  return {
    saveData: bindActionCreators(saveData, dispatch),
    changeAge: bindActionCreators(changeAge, dispatch),
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, matchDispatchToProps)(Question4)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/Adhoc/scenes/Question4/index.js